import React from 'react';
import { Table } from 'antd';
import Text from '../../../basicElement/Text';


export default function SpecificFteRequirement(props) {
    const { asterisk, data } = props;
    const { fteList } = data;

    const columns =  [{
        title: '时间',
        dataIndex: 'title',
        key: 'title',
        width: 80,
    }, {
        title: '计划FTE',
        dataIndex: 'value',
        key: 'value',
        width: 100,
    }];

    return (
        <li className="modal-item">
            <div className="item-left"><Text asterisk={asterisk} colon={true}>FTE需求</Text></div>
            <div className="item-right">
                <Table
                    columns={columns}
                    dataSource={fteList}
                    rowKey={record => record.title}
                    pagination={false}
                />
            </div>
        </li>
    );
}


// WEBPACK FOOTER //
// ./src/components/user/require/components/SpecificFteRequirement.js